// extracted by mini-css-extract-plugin
module.exports = {"button":"SpeakUp_button__32z9f","item":"SpeakUp_item__2Ihf-","item2":"SpeakUp_item2__2z-dD"};